import domtoimage from "dom-to-image";
// 数组对象去重
export function arrGoAgain(arr) {
  let newArr = [];
  let map = new Map();
  for (let item of arr) {
    if (!map.has(item.id)) {
      map.set(item.id, item);
    }
  }
  newArr = [...map.values()];
  return newArr;
}

// 设置storage
export function getStorage(key) {
  return localStorage.getItem(key);
}
// 获取设置storage
export function setStorage(key, value) {
  return localStorage.setItem(key, value);
}
// 删除storage
export function removeStorage(key) {
  return localStorage.removeItem(key);
}
// html转成base64
export function htmlToBase64(html, callback) {
  let baese64 = "";
  domtoimage.toPng(html).then((dataUrl) => {
    callback(dataUrl);
  });
}
